export const PERISCOPE_PICKLIST_COPY = {
	DESCRIPTION_MIDDLE: ' field, on the ',
	DESCRIPTION_PREFIX: 'A Picklist Value of the ',
	DESCRIPTION_SUFFIX: ' object.'
};
